import { oz } from '@weft/utils';
import { PeriodSchema, TimeSlotSchema } from '../../primitives';
import { MeasuredPriceBreakdownSchema } from './measure-price-breakdown-schema';
import { MeasuredPriceSchema } from './measured-price-schema';

export const NewUsageVariantChargeSchema = oz.object({
  accountId: oz.string(),
  customerId: oz.string(),
  contractId: oz.string(),
  invoiceId:  oz.string().nullish(),
  measurementId: oz.string(),
  productVariantId: oz.string(),
  meterId: oz.string(),
  period: PeriodSchema,
  timeSlot: TimeSlotSchema,
  measuredPrice: MeasuredPriceSchema,
  measuredPriceBreakdown: MeasuredPriceBreakdownSchema,
});

export type NewUsageVariantCharge = oz.infer<typeof NewUsageVariantChargeSchema>;